import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import imgixConfig from 'Config/imgix';

export default function WheelIntro({
  error,
  revealMysteryGame,
  skipAnimation,
  testReveal,
  smallprint,
}) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="MysteryReveal__content__intro">
      <div className="MysteryReveal__content__intro__logo--wheel">
        <img src={`https://fanatical.imgix.net/production/assets/mystery/spin-the-wheel/2024/black-friday-logo.png?${imgixConfig}`} alt="Black Friday Sale" />
      </div>
      <div className="MysteryReveal__content__intro__promoText">
        <FormattedMessage id="wheel-intro.promo-text" defaultMessage="Everyone's a winner this Black Friday! Spin the wheel to win free Steam games, coupons and star prizes!" />
      </div>
      {!error &&
        <React.Fragment>
          <button className="MysteryReveal__revealButton MysteryReveal__revealButton--blackfriday" onClick={() => { revealMysteryGame(); }}>
            {!testReveal &&
              <FormattedMessage id="wheel-intro.button.reveal" defaultMessage="Spin to win!" />
            }
            {testReveal &&
              <FormattedMessage id="wheel-intro.button.reveal.test" defaultMessage="Test spin" />
            }
          </button>
          {!testReveal &&
            <button className="MysteryReveal__skipButton" onClick={() => { setShowModal(true); }}>
              <FormattedMessage id="wheel-intro.button.skip" defaultMessage="Skip Animation" />
            </button>
          }
        </React.Fragment>
      }
      {error &&
        <div className="MysteryReveal__content__intro__clickText">
          <FormattedMessage id="wheel-intro.error" defaultMessage="Sorry there has been an issue with your item, please refresh and try again." />
        </div>
      }
      {!testReveal && smallprint &&
        <div className="MysteryReveal__content__intro__smallPrint">
          {smallprint}
        </div>
      }

      {showModal &&
        <div className="MysteryReveal__skipModal">
          <div className="MysteryReveal__skipModal__content">
            <div className="MysteryReveal__skipModal__content__title">
              <FormattedMessage id="wheel-intro.modal.title" defaultMessage="Are you sure you want to skip the animation?" />
            </div>
            <div className="MysteryReveal__skipModal__content__copy">
              <FormattedMessage id="wheel-intro.modal.copy" defaultMessage="Skipping will reveal all the games in your bundle instantly." />
            </div>
            <div className="MysteryReveal__skipModal__content__buttons">
              <button className="MysteryReveal__skipModal__content__button" onClick={() => { skipAnimation(); }}>
                <FormattedMessage id="wheel-intro.modal.button.yes" defaultMessage="Yes" />
              </button>
              <button className="MysteryReveal__skipModal__content__button" onClick={() => { setShowModal(false); }}>
                <FormattedMessage id="wheel-intro.modal.button.no" defaultMessage="No" />
              </button>
            </div>

            <button className="MysteryReveal__skipModal__exitButton" onClick={() => { setShowModal(false); }}>
              <FontAwesomeIcon icon={faXmark} title="Close modal" />
            </button>
          </div>
        </div>
      }
    </div>
  );
}

WheelIntro.propTypes = {
  error: PropTypes.bool,
  revealMysteryGame: PropTypes.func,
  skipAnimation: PropTypes.func,
  testReveal: PropTypes.bool,
  smallprint: PropTypes.string,
};

WheelIntro.defaultProps = {
  error: false,
  revealMysteryGame: () => {},
  skipAnimation: () => {},
  testReveal: false,
  smallprint: '',
};
